import React, { useEffect } from 'react';
import { Provider } from 'react-redux';
import ReduxToastr from 'react-redux-toastr';
import 'react-redux-toastr/lib/css/react-redux-toastr.min.css';
import { Router } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { PersistGate } from 'redux-persist/integration/react';
import '~/components/dependecies/dependecies';
import '~/config/ReactotronConfig';
import AppProvider from '~/hooks';
import Routes from '~/routes';
import history from '~/services/history';
import { persistor, store } from '~/store';
import Global from '~/styles/global';
import Layout from './layout';

const App: React.FC = () => {
  useEffect(() => {
    console.log(
      '%cStop!',
      'color:red;font-family:system-ui;font-size:4rem;-webkit-text-stroke: 1px black;font-weight:bold',
    );
    console.log(
      'Este é um recurso de navegador voltado para desenvolvedores. Se alguém disse para você copiar e colar algo aqui para ativar algum recurso ou "invadir" a conta de outra pessoa, isso é uma fraude e você dará a ele acesso à sua conta.',
    );
  }, []);
  return (
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <Router history={history}>
          <AppProvider>
            <Layout>
              <Routes />
            </Layout>
          </AppProvider>
          <Global />
          <ToastContainer autoClose={7000} />
        </Router>
      </PersistGate>
      <ReduxToastr
        timeOut={7000}
        newestOnTop={false}
        preventDuplicates
        transitionIn="fadeIn"
        transitionOut="fadeOut"
        progressBar
        closeOnToastrClick
      />
    </Provider>
  );
};

export default App;
